import { d as debounce } from "./utils-D8tYCXRD.js";
class Header extends HTMLElement {
  constructor() {
    super();
    this.setHeaderHeightVariable = this.setHeaderHeightVariable.bind(this);
  }
  connectedCallback() {
    this.cacheDomElements();
    this.setEventListeners();
    this.setHeaderHeightVariable();
  }
  cacheDomElements() {
    this.searchButton = this.querySelector(
      "[js-header='mobile-search']"
    );
    this.menuButton = this.querySelector(
      '[js-header="hamburger"]'
    );
    this.accountOverlayButton = this.querySelector(
      '[js-header="accountOverlay"]'
    );
    if (!this.searchButton || !this.menuButton) {
      console.error(
        "One or more critical elements are missing in the header component"
      );
    }
  }
  setEventListeners() {
    var _a, _b, _c;
    const mobileMenu = this.querySelector(
      "uwp-drawer[modal-name='mobile-menu']"
    );
    const accountOverlay = this.querySelector(
      "uwp-account-overlay[modal-name='account-overlay']"
    );
    (_a = this.menuButton) == null ? void 0 : _a.addEventListener("click", () => {
      mobileMenu == null ? void 0 : mobileMenu.showDrawer();
    });
    (_b = this.searchButton) == null ? void 0 : _b.addEventListener("click", () => {
      mobileMenu == null ? void 0 : mobileMenu.showDrawer();
    });
    (_c = this.accountOverlayButton) == null ? void 0 : _c.addEventListener("click", () => {
      accountOverlay == null ? void 0 : accountOverlay.toggleAccountOverlay();
    });
    window.addEventListener(
      "resize",
      debounce(this.setHeaderHeightVariable, 250)
    );
    document.addEventListener(
      "scroll",
      debounce(this.setHeaderHeightVariable, 250)
    );
    document.addEventListener(
      "announcement-bar:updated",
      this.setHeaderHeightVariable
    );
  }
  setHeaderHeightVariable() {
    const announcementBar = document.querySelector(
      "uwp-announcement-bar"
    );
    const secondaryAnnouncementBar = document.querySelector(
      ".secondary-announcement-bar"
    );
    const mainHeaderHeight = this.isElementInViewport(this) ? this.getVisibleHeight(this) : 0;
    const announcementBarHeight = announcementBar && this.isElementInViewport(announcementBar) ? this.getVisibleHeight(announcementBar) : 0;
    const secondaryAnnouncementBarHeight = secondaryAnnouncementBar && this.isElementInViewport(secondaryAnnouncementBar) ? this.getVisibleHeight(secondaryAnnouncementBar) : 0;
    const totalHeight = mainHeaderHeight + announcementBarHeight + secondaryAnnouncementBarHeight;
    document.documentElement.style.setProperty(
      "--header-height",
      `${totalHeight}px`
    );
  }
  isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0 && rect.left < (window.innerWidth || document.documentElement.clientWidth) && rect.right > 0;
  }
  getVisibleHeight(element) {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const visibleHeight = Math.max(
      0,
      Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0)
    );
    return visibleHeight;
  }
}
customElements.define("uwp-header", Header);
